import { useQuery } from '@tanstack/react-query'
import { Link } from 'react-router-dom'
import { Leaf, Sparkles, ShieldCheck } from 'lucide-react'
import { api } from '@/lib/api'
import { Seo } from '@/components/Seo'
import ProductCard from '@/components/ProductCard'
import { Skeleton } from '@/components/ui/skeleton'

const pillars = [
  { icon: Leaf, title: 'Thành phần lành tính', body: 'Chiết xuất thực vật, không cồn khô, không hương liệu tổng hợp — hợp cả với da nhạy cảm.' },
  { icon: Sparkles, title: 'Kết cấu mỏng nhẹ', body: 'Thẩm thấu nhanh, không bết dính, lớp nền lên mượt ngay sau khi dưỡng.' },
  { icon: ShieldCheck, title: 'Kiểm nghiệm da liễu', body: 'Mỗi lô hàng đều có phiếu kiểm nghiệm và hạn dùng in trên vỏ hộp.' },
]

export default function Home() {
  const featured = useQuery({
    queryKey: ['products', 'featured'],
    queryFn: () => api.products.list({ featured: true }),
  })

  return (
    <>
      <Seo />
      <section data-upbo-src="src/pages/Home.tsx:24" className="relative overflow-hidden border-b border-[#eedfda] bg-[#fdf8f6]">
        <div data-upbo-src="src/pages/Home.tsx:25" aria-hidden className="pointer-events-none absolute -right-24 -top-24 h-96 w-96 rounded-full bg-[#f3ddd6] blur-3xl" />
        <div data-upbo-src="src/pages/Home.tsx:26" className="relative mx-auto w-full max-w-6xl px-6 pt-24 pb-20">
          <p data-upbo-src="src/pages/Home.tsx:27" className="text-xs uppercase tracking-[0.28em] text-[#b3897f]">Mỹ phẩm cao cấp</p>
          <h1 data-upbo-src="src/pages/Home.tsx:28" className="mt-6 max-w-2xl text-balance text-5xl font-semibold leading-[1.05] tracking-[-0.03em] text-[#5f3f38] sm:text-6xl">
            Làn da rạng rỡ, chăm sóc từ điều giản dị
          </h1>
          <p data-upbo-src="src/pages/Home.tsx:31" className="mt-6 max-w-lg text-lg leading-relaxed text-[#9c7a72]">
            LumiSkin chọn lọc từng thành phần cho chu trình dưỡng da mỗi ngày — dịu nhẹ,
            hiệu quả, và đủ đẹp để bày trên bàn trang điểm.
          </p>
          <div data-upbo-src="src/pages/Home.tsx:35" className="mt-10 flex flex-wrap gap-3">
            <Link to="/cua-hang" className="rounded-full bg-[#7a4f45] px-7 py-3 text-sm font-medium text-white transition-colors hover:bg-[#63403a]">
              Khám phá cửa hàng
            </Link>
            <Link to="/gioi-thieu" className="rounded-full border border-[#e0c8c1] px-7 py-3 text-sm font-medium text-[#7a4f45] transition-colors hover:bg-[#f7ebe7]">
              Câu chuyện thương hiệu
            </Link>
          </div>
        </div>
      </section>

      <section data-upbo-src="src/pages/Home.tsx:46" className="mx-auto w-full max-w-6xl px-6 py-20">
        <div data-upbo-src="src/pages/Home.tsx:47" className="flex items-end justify-between gap-6">
          <h2 data-upbo-src="src/pages/Home.tsx:48" className="text-3xl font-semibold tracking-[-0.02em] text-[#5f3f38]">Sản phẩm nổi bật</h2>
          <Link to="/cua-hang" className="text-sm text-[#b3897f] hover:text-[#7a4f45]">Xem tất cả</Link>
        </div>
        <div data-upbo-src="src/pages/Home.tsx:51" className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {featured.isLoading && [0, 1, 2].map((i) => <Skeleton key={i} className="aspect-[3/4] rounded-2xl" />)}
          {featured.data?.map((product) => <ProductCard key={product.id} product={product} />)}
          {!featured.isLoading && featured.data?.length === 0 && (
            <p data-upbo-src="src/pages/Home.tsx:55" className="text-sm text-[#9c7a72]">Chưa có sản phẩm nổi bật nào.</p>
          )}
        </div>
      </section>

      <section data-upbo-src="src/pages/Home.tsx:60" className="border-t border-[#eedfda] bg-[#fdf8f6]">
        <div data-upbo-src="src/pages/Home.tsx:61" className="mx-auto grid w-full max-w-6xl gap-10 px-6 py-20 sm:grid-cols-3">
          {pillars.map((pillar) => (
            <div data-upbo-src="src/pages/Home.tsx:63" key={pillar.title}>
              <pillar.icon className="h-5 w-5 text-[#c98b7e]" />
              <h3 data-upbo-src="src/pages/Home.tsx:65" className="mt-4 text-base font-medium text-[#5f3f38]">{pillar.title}</h3>
              <p data-upbo-src="src/pages/Home.tsx:66" className="mt-2 text-sm leading-relaxed text-[#9c7a72]">{pillar.body}</p>
            </div>
          ))}
        </div>
      </section>
    </>
  )
}
